import _u from './util';
import _v from './vars';
import _fn from './shared-fn';

let opt = {
	'gradClr': '#44ab9f',
	'vLineClr': '#979797',
	'dotRadius': 3,
	'mkrRad': 3,
	'mkrW': 84,
	'mkrH': 30,
	'mkrPtH': 10,
	'mkrPtW': 16,
	'mkrGap': 3
}

let growthWidg = document.getElementById('avgSalGrowth');
let chtElem = null;
let salArr = null;
let salArrLast = null;
let salPxArr = null;
let salPxArrLast = null;
let inWidth = null;
let inHeight = null;
let outWidth = null;
let outHeight = null;
let vBarH = null;
let vBarNum = null;
let horW = null;
let hOffSt = null;
let vOffSt = null;
let selIndex = null;
let widgetInView = false;

function cSvg(elem, params) {
	let newElem = document.createElementNS("http://www.w3.org/2000/svg", elem);
	if (typeof params == 'object') {
		Object.keys(params).forEach(function(key) {
			newElem.setAttributeNS(null, key, params[key]);
		});
	}
	return newElem
}

function createGrad() {
	let gradDefs = cSvg('defs');
	let linGrad = cSvg('linearGradient', {
		'id': 'ln-fade',
		'x1': '0%',
		'x2': '0%',
		'y1': '0%',
		'y2': '100%'
	});
	let stopTop = cSvg('stop', {
		'offset': '0%',
		'class': 'slry-lg-mk-top'
	});
	let stopBottom = cSvg('stop', {
		'offset': '100%',
		'class': 'slry-lg-mk-btm'
	});

	linGrad.appendChild(stopTop);
	linGrad.appendChild(stopBottom);
	gradDefs.appendChild(linGrad);
	chtElem.appendChild(gradDefs);
}

function addVLines() {
	if (_u.qS('#slry-lg-svg line') != null) {
		_u.qS('#slry-lg-svg line').forEach(function(elem) {
			elem.parentNode.removeChild(elem);
		});
	}
	for (var x = 0; x <= vBarNum; x++) {
		let vLine = cSvg('line', {
			'class': 'slry-lg-vbar',
			'x1': hOffSt,
			'x2': inWidth + hOffSt,
			'y1': (x * vBarH) + vOffSt,
			'y2': (x * vBarH) + vOffSt
		});
		chtElem.appendChild(vLine);
	}
}

function addLineDots(linePts) {
	if (_u.qS('#slry-lg-svg circle') != null) {
		_u.qS('#slry-lg-svg circle').forEach(function(elem) {
			elem.parentNode.removeChild(elem);
		});
	}
	
	linePts.forEach(function(pt, idx) {
		let lineC = cSvg('circle', {
			'class': 'slry-lg-ci',
			'r': opt.dotRadius,
			'cx': idx * horW + hOffSt,
			'cy': (inHeight - pt) + vOffSt
		});
		chtElem.appendChild(lineC);
		
	});
}

let markerGroup = cSvg('g', {
	'class': 'slry-lg-mk-grp'
});

function addMarkers(instant) {	

	if (_u.qS('.slry-lg-mk') != null) {
		_u.qS('.slry-lg-mk').forEach(function(elem) {
			elem.parentNode.removeChild(elem);
		});
	}

	chtElem.appendChild(markerGroup);
	
	salPxArr.forEach(function(pt, idx) {		
		let clsNm = 'slry-lg-mk';
		if (idx == selIndex) {
			clsNm = 'slry-lg-mk selected';
		}
		let marker = cSvg('g', {
			'class': clsNm
		});
		
		let rect = cSvg('rect', {
			'x': idx * horW,
			'y': inHeight - pt,
			'rx': opt.mkrRad,
			'ry': opt.mkrRad,
			'width': opt.mkrW,
			'height': opt.mkrH
		});
		
		let poly = cSvg('polyline', {
			'points': (idx * horW - opt.mkrPtW / 2 + hOffSt) + ',' + (inHeight - pt + opt.mkrH) + ' ' + (idx * horW + hOffSt) + ',' + (inHeight - pt + opt.mkrH + opt.mkrPtH) + ' ' + (idx * horW + opt.mkrPtW / 2 + hOffSt) + ',' + (inHeight - pt + opt.mkrH)
		});
		
		clsNm = 'slry-lg-mk-txt';
		if (idx == selIndex) {
			clsNm = 'slry-lg-mk-txt selected';
		}
		let text = cSvg('text', {
			'class': clsNm,
			'x': idx * horW + hOffSt - opt.txtOffX,
			'y': inHeight - pt + opt.mkrH / 2 + opt.txtOffY
		})
		let roundSal = String(Math.round(salArr[idx] / 10000) * 10000);
		roundSal = roundSal.substring(0, roundSal.match(/\d\d\d$/).index);
		if (roundSal.length == 4) {
			text.textContent = '$' + roundSal.replace(/^(\d)/,"$1.").replace(/\d$/,'') + 'M';
		} else {
			text.textContent = '$' + roundSal + 'K';
		}

		marker.appendChild(rect);
		marker.appendChild(poly);
		marker.appendChild(text);
		if (instant) {
			marker.setAttributeNS(null, "class", marker.getAttribute("class") + " instant active");
			setTimeout(function() {
				marker.setAttributeNS(null, "class", marker.getAttribute("class").replace(' instant',''));
			}, 250);
		} else {
			setTimeout(function() {
				marker.setAttributeNS(null, "class", marker.getAttribute("class") + " active");
			}, 1);
		}
		markerGroup.appendChild(marker);	
	});
		
	if (instant) {
		setTimeout(function() {
			_u.qS('.slry-lg-mk').forEach(function(elem) {
				elem.setAttributeNS(null, "class", elem.getAttribute("class").replace(' instant',''));
			});
		}, 250);
	}
	
}

function addLineG(linePts) {
	if (_u.qS('.slry-lg-ln, #slry-lg-svg polygon') != null) {
		document.querySelectorAll('.slry-lg-ln, #slry-lg-svg polygon').forEach(function(elem) {
			elem.parentNode.removeChild(elem);
		});
	}
	let lnPts = "";
	for (var x = 0; x < linePts.length; x++) {
		lnPts = lnPts + (x * horW + hOffSt) + ',' + (inHeight - linePts[x] + vOffSt) + ' ';
	}

	let lineG = cSvg('polyline', {
		'class': 'slry-lg-ln',
		'points': lnPts
	});

	let lineGB = cSvg('polygon', {
		'class': 'slry-lg-ln-fill',
		'points': hOffSt + ',' + (inHeight + vOffSt) + ' ' + lnPts + ' ' + (inWidth + hOffSt) + ',' + (inHeight + vOffSt)
	});

	chtElem.appendChild(lineG);
	chtElem.appendChild(lineGB);

	addLineDots(linePts);
}

function animateGraph() {
	document.removeEventListener('avgSalGrowthInView', animateGraph);
	let animDone = new Promise(function(resolve, reject) {	
		function pxStep(timestamp) {	
			let matchCount = 0;
			
			salPxArr.forEach(function(pxVal, idx) {
				if (salPxArr[idx] > salPxArrLast[idx] && salPxArr[idx] - salPxArrLast[idx] >= 5) {
					salPxArrLast[idx] = salPxArrLast[idx] + 5;
				} else if (salPxArr[idx] < salPxArrLast[idx] && salPxArrLast[idx] - salPxArr[idx] >= 5) {
					salPxArrLast[idx] = salPxArrLast[idx] - 5;
				}
				else {
					salPxArrLast[idx] = salPxArr[idx];
					matchCount++;
				}
			});
			
			addLineG(salPxArrLast); // Draw Line / BG / Points
			
			if (!(matchCount >= salPxArr.length)) {
				window.requestAnimationFrame(pxStep);
			} else {
				resolve();
			}
		}
		window.requestAnimationFrame(pxStep);
	});
	
	animDone.then(addMarkers); // Label Points
}

function createGraph(sals, selIdx, e) {
/* sals = array of salaries
   selIdx = highlighted salary marker */
	if (typeof sals.length != 'undefined' && sals.length > 0) {

		// Set BP-specific size vars
		if (breakpoint < 3) {
			Object.assign(opt, {
				'mkrW': 62,
				'mkrH': 23,
				'mkrPtH': 6,
				'mkrPtW': 10,
				'txtOffX': 23,
				'txtOffY': 5
			});
		} else {
			Object.assign(opt, {
				'mkrW': 84,
				'mkrH': 30,
				'mkrPtH': 10,
				'mkrPtW': 16,
				'txtOffX': 30,
				'txtOffY': 6
			});
		}
		
		// Get function params
		salArr = sals;		
		if (typeof selIdx != 'undefined' && selIdx != null) {
			selIndex = selIdx;
		}

		// Calculated Salary Vars
		let salArrSort = salArr.slice();
		salArrSort.sort(function(a, b) {
			return a - b
		});
		let highVal = Math.ceil(salArrSort[salArrSort.length - 1] / 100000) * 100000;
		let lowVal = Math.floor(salArrSort[0] / 100000) * 100000;
		let valRange = highVal - lowVal;

		// Calculated Widths etc.
		if (valRange >= 300000) {
			vBarNum = Math.floor(valRange / 100000);
		} else {
			vBarNum = Math.floor(valRange / 50000);
		}
		hOffSt = opt.mkrW / 2;
		vOffSt = opt.dotRadius * 2 + opt.mkrH + opt.mkrPtH + opt.mkrGap;
		let horNum = salArr.length - 1;
		outHeight = _u.qS('.slry-lg-svg-wrap').clientHeight;
		inHeight = outHeight - vOffSt - (opt.dotRadius * 2);
		outWidth = _u.qS('.slry-lg-svg-wrap').clientWidth;
		inWidth = outWidth - hOffSt * 2;
		horW = inWidth / horNum;
		vBarH = inHeight / vBarNum;
		
		// Get animation starting point
		if (salPxArr != null) { // If previous salaries were loaded
			salPxArrLast = salPxArr;
		} else { // If first run, start at bottom
			salPxArrLast = [];
			for (let x = 0; x < salArr.length; x++) {
				salPxArrLast.push(vOffSt); // Bottom of graph for first load
			}
		}

		// Convert salaries to pixel coordinates
		let moneyToPixRatio = valRange / inHeight;
		salPxArr = [];
		for (let y = 0; y < salArr.length; y++) {
			salPxArr.push(((Math.round(salArr[y] / 10000) * 10000) - lowVal) / moneyToPixRatio);
		}

		// Prepare SVG		
		if (_u.qS('#slry-lg-svg') == null) {
			chtElem = cSvg('svg');
			chtElem.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
			chtElem.id = 'slry-lg-svg';
			chtElem.setAttributeNS(null, "height", '100%');
			chtElem.setAttributeNS(null, "width", '100%');		
			createGrad(); // Append SVG Gradient Tags
			_u.qS('.slry-lg-svg-wrap').appendChild(chtElem);
		}

		addVLines(); // Horizontal Gray Lines along Y-Axis
		
		if (widgetInView && typeof e == 'undefined') {			
			let removeMarkerDone = new Promise(function(resolve, reject) {	
				if (_u.qS('.slry-lg-mk') != null) { 
					_u.qS('.slry-lg-mk').forEach(function(elem) {
						elem.setAttributeNS(null, "class", elem.getAttribute("class").replace(' active',''));
					});
					setTimeout(function() {
						_u.qS('.slry-lg-mk').forEach(function(elem) {
							elem.parentNode.removeChild(elem);
						});
						resolve();
					}, 300); // wait for fade out
				}
				else {
					resolve();
				}
			});		
			removeMarkerDone.then(animateGraph);		
		}
		else if (typeof e != 'undefined') {
			addLineG(salPxArr);
			addMarkers(true);
		}
		else {								
			if (_u.qS('.slry-lg-mk') != null) {					
				_u.qS('.slry-lg-mk').forEach(function(elem) {
					elem.parentNode.removeChild(elem);
				});
			}		
			document.addEventListener('avgSalGrowthInView', animateGraph);			
		}
		
	}
}

window.addEventListener('scroll', function() {
	let lastVis = widgetInView;
	if (growthWidg.offsetParent != null && (growthWidg.getBoundingClientRect().top + growthWidg.getBoundingClientRect().height/1.25) < window.innerHeight && (growthWidg.getBoundingClientRect().bottom - growthWidg.getBoundingClientRect().height/1.25) >= 0) {
		widgetInView = true;
	} else {
		widgetInView = false;
	}
	if (widgetInView != lastVis && widgetInView) {
		document.dispatchEvent(new CustomEvent('avgSalGrowthInView'));
	}
});

export default createGraph;